"use strict";exports.isNumericString=function(i){return!isNaN(i)&&!isNaN(parseFloat(i))};
//# sourceMappingURL=isNumericString.cjs.map
